/* eBikeXL winkelmand-regel: upgrade-producten mogen alleen samen met een e-bike worden afgerekend.
   - Add-on = producttype begint met "add-on" (bv. "Add-ons (UA)")
   - Fiets  = gevuld producttype dat geen add-on en geen accessoire is (losse opladers met leeg type tellen niet mee)
   - Blokkeren = er zit een add-on in de mand EN er zit geen fiets in de mand
   Werkt op de winkelmandpagina en in de cart-drawer, ook na AJAX-updates. */
(function () {
  'use strict';

  var MSG = 'Let op: een upgrade kan alleen samen met de aanschaf van een e-bike worden besteld. Voeg eerst een e-bike toe aan je winkelwagen.';
  var NON_BIKE = ['add-on', 'oplader', 'lader', 'accessoire', 'onderdeel', 'slot', 'telefoonhouder', 'cadeaubon', 'gift'];

  var blocked = false;

  function norm(s) { return (s == null ? '' : String(s)).toLowerCase().trim(); }

  function isAddon(item) {
    return norm(item.product_type).indexOf('add-on') === 0;
  }

  function isBike(item) {
    var t = norm(item.product_type);
    if (!t) return false;
    for (var i = 0; i < NON_BIKE.length; i++) {
      if (t.indexOf(NON_BIKE[i]) !== -1) return false;
    }
    return true;
  }

  function checkoutEls() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#bt_checkout, #CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]')
    );
  }

  function ensureNotice(refEl, id) {
    var n = document.getElementById(id);
    if (!n) {
      n = document.createElement('div');
      n.id = id;
      n.className = 'ebx-cart-notice';
      n.setAttribute('role', 'alert');
      n.style.cssText = 'margin:12px 0;padding:12px 14px;border-radius:8px;background:#fdecea;border:1px solid #f3b6bd;color:#8a1f2b;font-size:14px;line-height:1.45;font-weight:500;';
      n.textContent = MSG;
      if (refEl && refEl.parentNode) refEl.parentNode.insertBefore(n, refEl);
    }
    return n;
  }

  function applyState() {
    checkoutEls().forEach(function (btn) {
      var nid = 'ebx-cart-notice-' + (btn.id || btn.name || 'x');
      if (blocked) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('ebx-checkout-blocked');
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        ensureNotice(btn, nid).style.display = 'block';
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('ebx-checkout-blocked');
        btn.style.opacity = '';
        btn.style.cursor = '';
        var ex = document.getElementById(nid);
        if (ex) ex.style.display = 'none';
      }
    });
    Array.prototype.slice.call(
      document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, [data-shopify="payment-button"]')
    ).forEach(function (el) { el.style.display = blocked ? 'none' : ''; });
  }

  function evaluate() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var hasAddon = items.some(isAddon);
        var hasBike = items.some(isBike);
        blocked = hasAddon && !hasBike;
        applyState();
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest
      ? e.target.closest('#bt_checkout, #CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]')
      : null;
    if (t && blocked) {
      e.preventDefault();
      e.stopPropagation();
      var nid = 'ebx-cart-notice-' + (t.id || t.name || 'x');
      var n = document.getElementById(nid) || ensureNotice(t, nid);
      n.style.display = 'block';
      n.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (blocked && f && (f.id === 'cart' || f.id === 'CartDrawer-Form')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : arguments[0];
      var p = _fetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
        p.then(function () { setTimeout(evaluate, 150); }).catch(function () {});
      }
      return p;
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
          this.addEventListener('load', function () { setTimeout(evaluate, 150); });
        }
      } catch (e) {}
      return _open.apply(this, arguments);
    };
  }

  function observe() {
    ['#CartDrawer', '#CartDrawer-CartItems', '#main-cart-items', '#main-cart-footer', '.ap-cartdrawer']
      .forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el && window.MutationObserver) {
          new MutationObserver(function () { applyState(); }).observe(el, { childList: true, subtree: true });
        }
      });
  }

  function init() {
    evaluate();
    observe();
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest('[href="/cart"], a[href*="/cart"], .cart-link, #cart-icon-bubble, [data-cart-toggle], .header__icon--cart')
        : null;
      if (t) setTimeout(evaluate, 350);
    });
    setTimeout(evaluate, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
